






































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import Spinner from "vue-spinner-component/src/Spinner.vue";
import { Token } from "../utils/Token";

@Component({
  components: {
    Spinner,
  },
})
export default class ConfirmationModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly type!: string;
  @Prop() readonly user!: any;
  @Prop() readonly device!: any;
  @Prop() readonly dataType!: string;

  private errorModalFlag = false;
  private errorText = "";
  private errorTitle = "Error";

  private buttonsDisabled = false;
  private loading = true;

  private spinnerStatus = false;

  created() {
    EventBus.$off('closeErrorModal')
    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
      EventBus.$emit("closeConfirmationModal", value);
    });
  }
  

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeConfirmationModal", value);
  }

  private submitData() {
    console.log("submit");
    console.log(this.dataType);
    if (this.dataType === "user") {
      this.submitUser();
    } else if (this.dataType === "device") {
      this.submitDevice();
    } else {
      console.log("Invalid or unset dataType");
    }
  }

  private async submitDevice() {
    this.buttonsDisabled = true;
    this.spinnerStatus = true;
    this.errorText = "";
    const token = await Token.getTokenWithExpiry("token");

    if (this.type === "create") {
      axios({
        method: "post",
        url: `${process.env.VUE_APP_BASE_URL}/device`,
        data: this.device,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {

          if (response.data.code == 401) {
            EventBus.$emit("LogOutEventBus", false);
          } else {
            console.log("successful create API response:", response);
            console.log("with code:", response.data.code);
            this.buttonsDisabled = false;
            this.spinnerStatus = false;
            if (response.data.code == 200) {
              this.closeModal();
            } else if (response.data.code != 200) {
              this.errorText = response.data.error.message;
              this.errorModalFlag = true;

            }
          }
        })
        .catch((err) => {
          console.log("failed API call:", err);
          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          this.errorText = "There was an error in creating the device.";
          this.errorModalFlag = true;
        });
    } else {
      console.log("update device");
      const id = this.user.accountId;

      const data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        description: this.user.description,
        email:this.user.email,
        location: this.user.location,
        statusCode: this.user.accountStatus ? 100 : 101, //user has accountStatus=100 if enabled and 101 if disabled
      };
      axios({
        method: "put",
        url: `${process.env.VUE_APP_BASE_URL}/device/${id}`,
        data: data,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => { 

          console.log("successful edit API response:", response);
          console.log("with code:", response.data.code);

          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          if (response.data.code == 200) {
            //success
            this.closeModal();
          } else {
            //fail
            console.log("bad response code");
            this.errorText = "There was an error in updating the device.";
            this.errorModalFlag = true;
          }
        })
        .catch((err) => {
          console.log("failed edit API call:", err);
          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          this.errorText = "There was an error in updating the device.";
          this.errorModalFlag = true;
        });
    }
  }

  private async submitUser() {
    this.buttonsDisabled = true;
    this.spinnerStatus = true;
    this.user.extension = Number(this.user.extension);
    this.errorText = "";

    const token = await Token.getTokenWithExpiry("token");

    if (this.type === "create") {
      //CREATE API CALL
      console.log("user to be created:", this.user);

      axios({
        method: "post",
        url: `${process.env.VUE_APP_BASE_URL}/account`,
        data: this.user,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {

          if (response.data.code == 401) {
            EventBus.$emit("LogOutEventBus", false);
          } else {
            console.log("successful create API response:", response);
            console.log("with code:", response.data.code);

            this.buttonsDisabled = false;
            this.spinnerStatus = false;
            if (response.data.code == 200) {
              //success
              this.closeModal();
            } else if (response.data.code == 409) {
              //fail
              console.log("bad response code");
              this.errorText = "There is already a user with this extension";
              this.errorModalFlag = true;
            }
          }
        })
        .catch((err) => {
          console.log("failed API call:", err);
          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          this.errorText = "There was an error in creating the user.";
          this.errorModalFlag = true;
        });
    } else {
      // UPDATE API CALL
      console.log("user to be edited:", this.user);
      const id = this.user.accountId;

      const data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        extension: this.user.extension,
        description: this.user.description,
        statusCode: this.user.accountStatus ? 100 : 101, //user has accountStatus=100 if enabled and 101 if disabled
        
      };
      axios({
        method: "put",
        url: `${process.env.VUE_APP_BASE_URL}/account/${id}`,
        data: data,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {

          console.log("successful edit API response:", response);
          console.log("with code:", response.data.code);

          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          if (response.data.code == 200) {
            //success
            this.closeModal();
          } else {
            //fail
            console.log("bad response code");
            this.errorText = "There was an error in updating the user.";
            this.errorModalFlag = true;
          }
        })
        .catch((err) => {

          console.log("failed edit API call:", err);
          this.buttonsDisabled = false;
          this.spinnerStatus = false;
          this.errorText = "There was an error in updating the user.";
          this.errorModalFlag = true;
        });
    }
  }
  

  private closeModal() {
    const snackbarData = {
      text:
        this.type === "create"
          ? "User has been created. Creation of USB device in progress..."
          : "User has been updated",
      color: this.type === "create" ? "#4caf50" : "#2196f3",
    };

    EventBus.$emit("closeEditAccountModal", false);
    EventBus.$emit("closeCreateAccountModal", false);

    EventBus.$emit("closeEditDeviceModal", false);
    EventBus.$emit("closeCreateDeviceModal", false);

    EventBus.$emit("refreshListing");
    EventBus.$emit("showSnackbar", snackbarData);
  }

  private cancelModal() {
    EventBus.$emit("closeConfirmationModal", false);
  }
}
